import axios from "axios";

const API = axios.create({ baseURL: "https://shivansh-portfolio-nkyo.onrender.com/api" });

// ✅ Attach token to requests for authentication
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// ✅ Get all blogs with pagination, filtering, and search
export const getAllBlogs = async (page = 1, category = "", search = "") => {
  try {
    const params = new URLSearchParams({ page });
    if (category) params.append("category", category);
    if (search) params.append("search", search);

    const response = await API.get(`/blogs?${params.toString()}`);
    console.log("✅ API Response:", response.data);

    return { blogs: response.data.blogs || [], totalPages: response.data.totalPages || 1 };
  } catch (error) {
    console.error("❌ Error fetching articles:", error.response?.data || error.message);
    return { blogs: [], totalPages: 1 }; // Prevent crash
  }
};

// ✅ Get a single blog by ID
export const getSingleBlog = async (id) => {
  try {
    const response = await API.get(`/blogs/${id}`);
    return response.data || {}; // Ensure it always returns an object
  } catch (error) {
    console.error("❌ Error fetching blog:", error.response?.data || error.message);
    return null; // Prevent crash
  }
};

// ✅ Add a new blog (Admin Only)
export const addBlog = async (blog) => {
  try {
    const response = await API.post("/blogs", blog);
    return response.data;
  } catch (error) {
    console.error("❌ Error adding blog:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Update an existing blog (Admin Only)
export const updateBlog = async (id, updatedBlog) => {
  try {
    const response = await API.put(`/blogs/${id}`, updatedBlog);
    return response.data;
  } catch (error) {
    console.error("❌ Error updating blog:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Delete a blog (Admin Only)
export const deleteBlog = async (id) => {
  try {
    const response = await API.delete(`/blogs/${id}`);
    return response.data;
  } catch (error) {
    console.error("❌ Error deleting blog:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Update a project (Admin Only)
export const updateProject = async (id, updatedProject) => {
  try {
    const response = await API.put(`/projects/${id}`, updatedProject);
    return response.data;
  } catch (error) {
    console.error("❌ Error updating project:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Send contact message
export const sendContactMessage = async (formData) => {
  try {
    const response = await API.post("/send-email", formData);
    return response.data;
  } catch (error) {
    console.error("❌ Error sending contact message:", error.response?.data || error.message);
    throw error;
  }
};
